module.exports = __webpack_public_path__ + "static/media/spice-jet-tail.30695a56.png";